var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtlTestingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5673_18506",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5673_18506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 20.75V4.50004H11.1152C11.0641 4.75004 11.0231 5.00004 10.9922 5.25004C10.9616 5.50004 10.9546 5.75004 10.9713 6.00004H7V12H14.25L14.65 14H18V12.3595C18.25 12.3532 18.5 12.3315 18.75 12.2943C19 12.2571 19.25 12.2014 19.5 12.127V15.5H13.404L13.004 13.5H7V20.75H5.5ZM16.9385 7.83079L20.346 4.43854L19.5078 3.60004L16.9385 6.13854L15.8 5.00004L14.9615 5.85379L16.9385 7.83079ZM17.6538 1.19629C18.9026 1.19629 19.9648 1.63412 20.8403 2.50979C21.7159 3.38529 22.1538 4.44746 22.1538 5.69629C22.1538 6.94496 21.7159 8.00712 20.8403 8.88279C19.9648 9.75829 18.9026 10.196 17.6538 10.196C16.4051 10.196 15.3429 9.75829 14.4672 8.88279C13.5916 8.00712 13.1538 6.94496 13.1538 5.69629C13.1538 4.44746 13.5916 3.38529 14.4672 2.50979C15.3429 1.63412 16.4051 1.19629 17.6538 1.19629Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtlTestingIcon);
export default __webpack_public_path__ + "static/media/ETLTestingIcon.5571a7c913bdf76b573d9514e0b4db65.svg";
export { ForwardRef as ReactComponent };